<script setup>
const props = defineProps({
    items: {
        type: Array,
        default: []
    },
    initialValue: {
        type: Array,
        default: null
    }
})

const emits = defineEmits(['updateFilter'])
const updateFilter = (values) => {
    const valuesS = values.length ? values.map((item) => item.id) : []
    emits('updateFilter', valuesS)
}

const filterValues = ref([])

onMounted(() => {
    if (props.initialValue) {
        filterValues.value = props.items.filter((item) => {
            return [...props.initialValue].includes(`${item.id}`)
        })
    }
})

watch(filterValues, (newValue) => {
    updateFilter(newValue)
})
</script>
<template>
    <div class="single-filter-ui d-flex">
        <v-checkbox
            v-for="(item, index) in items"
            :key="index"
            v-model="filterValues"
            chips
            multiple
            :label="item.name"
            :value="item"
        ></v-checkbox>
    </div>
</template>
